<div class="footer bg-secondary">
	<div class="copyright">Copyright ©{{ currentYear }} Tenderpilot GmbH</div>
	<ul>
		<li class="mr-1">
			<a href="{{ 'global.common.footer.agb_link' | translate }}" target="_blank">{{'global.common.footer.agb' | translate}}</a>
		</li>
		<li class="mr-1">
			<a href="{{'global.common.footer.about_us_link' | translate}}" target="_blank">{{'global.common.footer.about_us' | translate}}</a>
		</li>
		<li class="mr-1">
			<a href="{{'global.common.footer.faq_link' | translate}}" target="_blank">{{'global.common.footer.faq' | translate}}</a>
		</li>
		<li class="mr-1">
			<a href="{{'global.common.footer.roadmap_link' | translate}}">{{'global.common.footer.roadmap' | translate}}</a>
		</li>
		<li class="mr-1">
		<a href="{{'global.common.footer.maintenance_link' | translate}}">{{'global.common.footer.maintenance' | translate}}</a>
		</li>
		<li>
			{{ currentVersion }}
		</li>
	</ul>
</div>
